import { Injectable } from '@angular/core';
import { Router, CanActivate,ActivatedRoute } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(public auth: AuthService, public router: Router,private route: ActivatedRoute) {
    
  }

  canActivate(): boolean {
    
    if (!this.auth.isAuthenticated()) {
      
      localStorage.setItem('redirectUrl', this.router.url);
      this.router.navigate(['/configure']);
      return false;
    }


    return true;
  }

}


// WEBPACK FOOTER //
// /Users/andrescufari/Angular/billbo-desktop-v2/src/app/services/auth.guard.ts